import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Typography from 'components/Typography';

import backImg from 'assets/arrow_back.svg';

import { NavigatorContainer, NavigatorImg } from './Navigator.styled.ts';
import type { NavigatorProps } from './Navigator.types.ts';

const Navigator: FC<NavigatorProps> = ({ title, to }) => {
  const navigate = useNavigate();

  return (
    <NavigatorContainer>
      <NavigatorImg
        src={backImg}
        onClick={() => (to ? navigate(to) : navigate(-1))}
      />
      <Typography type="Title" size="small" style="extralight" color="#0C0C0C">
        {title}
      </Typography>
    </NavigatorContainer>
  );
};

export default Navigator;
